import React, {useRef, useState, useMemo, useCallback} from "react";
import classNames from "classnames";
import "./style.css";
import { useEffect } from "react";
import useWindowDimensions from "@helpers/hooks/windowDemensions";

const Input = (props) => {
  const inputRef = useRef();
  const [isActive, setActive] = useState(false);
  const [hasValue, setHasValue] = useState(!!props.value);
  const [isTyping, setIsTyping] = useState(false);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(!!props.value);

  useEffect(() => {
    if(props.autoFocus) {
      if (inputRef.current){
        inputRef.current.focus();
      }
    }
  }, [props.autoFocus]);

  useEffect(() => {
    setHasValue(!!props.value);
    // If the field gets a value from props, consider it as validated
    if (!!props.value) {
      setHasBeenBlurred(true);
    }
  }, [props.value]);

  const handleActive = (e) => {
    setActive(true);
    setHasValue(!!e.target.value);
    setIsTyping(true);
  }

  const handleBlur = (e) => {
    setActive(false);
    setHasValue(!!e.target.value);
    setHasBeenBlurred(true);
    setIsTyping(false);
  }

  const handleChange = (e) => {
    setHasValue(!!e.target.value);
    setIsTyping(true);
    if (props.onChange) {
      props.onChange(e);
    }
  }

  const handleClear = useCallback((e) => {
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.value = '';
      setHasValue(false);
      
      // Create a synthetic event to pass to onChange
      const syntheticEvent = {
        target: inputRef.current
      };
      
      if (props.onChange) {
        props.onChange(syntheticEvent);
      }
      
      // Focus the input after clearing
      inputRef.current.focus();
    }
  }, [props.onChange]);

  const inputType = useMemo(() => {
    if (props.type) return props.type; // explicit override (gift form re-uses this field UI)
    if (props.name === "phoneNumber") return "tel";
    else if (props.name === "email") return "email";
    return "text";
  }, [props.name, props.type]);

  // Only show the X button if the field has a value, has been blurred, is not currently being typed in, and is not a zipCode field
  const showClearButton = hasValue && hasBeenBlurred && !isTyping && props.name !== 'zipCode';

  return (
    <div className={classNames({'input-wrapper-required': props.isRequired && !hasValue})} {...props} style={{position: "relative"}}>
      <label
        className={classNames("blends-input-label2", {'blends-input-label2-filled': isActive})}
        htmlFor={props.name}
        style={{ right: !props.icon && isActive ? "16px" : props.name === 'zipCode'? '57px' : "68px", top: isActive ? "-6px" : "25px", opacity: isActive ? 1 : 0}}
      >
        {props.label}
      </label>
      <div
        className={classNames('blends-input-wrapper2',
            {error: props.error},
            {'blends-input-active': isActive},
            {'blends-input-active-phone': isActive && props.name === 'phoneNumber'},
            {'blends-input-error-phone': props.error && props.name === 'phoneNumber'}
            )}
            {...props}>
        {props.icon && <>
            <span className="blends-input2-icon">
              {props.icon}
            </span>
            <span className={classNames('blends-input2-divider', {'blends-input-divider-filled': inputRef.current?.value})}></span>
          </>
        }
        <input
          id={props.name}
          className={classNames('blends-input2', {'blends-input2-center': props.name === 'zipCode'})}
          style={{minWidth: "calc(100% - 55px)"}}
          placeholder={ isActive ? '' : props.placeholder}
          ref={inputRef}
          autoFocus={props.autoFocus}
          onFocus={handleActive}
          onBlur={handleBlur}
          onChange={handleChange}
          type={inputType}
          defaultValue={props.value}
          maxLength={props.maxLength}
          max={props.maxValue}
          inputMode={props.inputMode || (props.name === "phoneNumber" ? "numeric" : null)}
          />
        {showClearButton && (
          <button 
            type="button"
            className="blends-input-clear-button"
            onClick={handleClear}
            aria-label="Clear input"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Input;
